import { useCallback } from 'react'
import { useParams, generatePath } from 'react-router-dom'

import { Layout } from 'admin/lib/Layouts'
import { Breadcrumb, BreadcrumbArrayItem } from 'admin/lib/Breadcrumbs'
import { useApiQuery } from 'admin/lib/Api'
import { EditConnection } from './EditConnection'
import { ScreenSpin } from 'admin/lib/ScreenSpin'
import styled from 'styled-components'
import { GetPageNames } from 'admin/lib/GetPageNames'

import * as ROUTES from 'admin/routes'

export function Connection() {
  const { accountId, projectId, connectionId: paramsConnectionId } = useParams()

  const connectionId = paramsConnectionId ? paramsConnectionId : 'register'

  const connection = useApiQuery(
    useCallback(
      api => {
        if (connectionId === 'register') {
          return [{}, null, null]
        }
        return api.getConnection(accountId, projectId, connectionId)
      },
      [accountId, connectionId, projectId]
    )
  )

  const instruments = useApiQuery(
    useCallback(
      api => {
        if (connectionId === 'register') {
          return [[], null, null]
        }
        return api.getConnectionInstruments(accountId, projectId, connectionId)
      },
      [accountId, connectionId, projectId]
    )
  )

  const pageNames = GetPageNames(accountId, projectId, connectionId)

  return (
    <Layout
      header={
        <Breadcrumb
          items={[
            {
              title: (
                <BreadcrumbArrayItem href={generatePath(ROUTES.ACCOUNTS.LIST)}>
                  Accounts
                </BreadcrumbArrayItem>
              )
            },
            {
              title: (
                <BreadcrumbArrayItem
                  href={generatePath(ROUTES.PROJECTS.LIST, {
                    accountId: accountId
                  })}
                >
                  {pageNames.data && pageNames.data.accountName}
                </BreadcrumbArrayItem>
              )
            },
            {
              title: (
                <BreadcrumbArrayItem
                  href={generatePath(ROUTES.CONNECTIONS.LIST, {
                    accountId: accountId,
                    projectId: projectId
                  })}
                >
                  {pageNames.data && pageNames.data.projectName}
                </BreadcrumbArrayItem>
              )
            },
            {
              title: (
                <BreadcrumbArrayItem>
                  {pageNames.data && pageNames.data.connectionName}
                </BreadcrumbArrayItem>
              )
            }
          ]}
        />
      }
    >
      {(!connection.loaded || !instruments.loaded) && <ScreenSpin />}

      {connection.loaded && instruments.loaded && (
        <EditSection>
          <EditConnection
            connection={connection.data}
            instruments={instruments.data}
            isNew={connectionId === 'register'}
            accountId={accountId}
            projectId={projectId}
          />
        </EditSection>
      )}
    </Layout>
  )
}

const EditSection = styled.div`
  margin: auto;
  width: 30rem;
`
